import { Button } from "shared/components/Button";
import { MaxWidth } from "shared/components/MaxWidth";
import { RichText } from "shared/components/RichText";
import { SMALL } from "shared/utils/constants";
import styles from "./PageNotFound.module.css";

export const PageNotFound = ({ button, text, title }) => (
  <div className={styles.container}>
    <MaxWidth size={SMALL}>
      <RichText>
        {title && <h1>{title}</h1>}
        {text && <p>{text}</p>}
      </RichText>
      {button && <Button {...button}>{button?.label}</Button>}
    </MaxWidth>
  </div>
);
